import React, { useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "./SecureShoppingInformation.css";

import EtbisNewLogo from "../../assets/shopping/etbislogo.webp";
import TimLogo from "../../assets/shopping/timlogo.webp";
import IkbimLogo from "../../assets/shopping/ikmib-logo.webp";

import UPSlogo from "../../assets/secureshop/upsnewlogo.webp";
import DHLlogo from "../../assets/secureshop/dhlexpressson.webp";
import Feedexlogo from "../../assets/secureshop/fedexnewlogo.webp";
import DHLElogo from "../../assets/secureshop/dhlecommercenewlogo.webp";
import ImmisLogo from "../../assets/secureshop/test.webp";

import IyzicoLogo from "../../assets/secureshop/iyzicologo.webp";
import PaypalLogo from "../../assets/secureshop/paypallogo.webp";

import { FreeMode, Pagination } from "swiper/modules";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";

import InstallmentData from "../../api/InstallmentOptions"; // doğru yoldan import etmeyi unutma
const SecureShoppingInformation = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("secure.meta.title"),
      description: t("secure.meta.description"),
      keywords: t("secure.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);
  return (
    <div className="container py-5">
      <div className="col-lg-12 mb-5 text-center">
        <h4 className="fw-light">{t("SecureShoppingTitle")}</h4>
      </div>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-lg-6 col-sm-8 col-md-6 text-center">
          <h5 className="fw-light text-center my-5 p-3">
            {t("PaymentOptions")}
          </h5>

          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            pagination={{
              clickable: true,
            }}
            modules={[FreeMode, Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 2,
              },
            }}
          >
            <SwiperSlide className="mb-5">
              <img src={IyzicoLogo} width={250} height={80} alt="iyzicologo" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={PaypalLogo} width={250} height={80} alt="paypallogo" />
            </SwiperSlide>
          </Swiper>

          <h5 className="fw-light text-center my-5 p-3">
            {t("InstallmentOptions")}
          </h5>

          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            modules={[FreeMode, Pagination]}
            className="mySwiper"
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {InstallmentData.blogs.map((item) => (
              <SwiperSlide key={item.id} className="mb-5">
                <img
                  src={item.images}
                  alt={item.alt}
                  width={170}
                  height={50}
                  style={{ objectFit: "contain" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <h5 className="fw-light text-center my-5 p-3">
            {t("OrderTracking")}
          </h5>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            pagination={{
              clickable: true,
            }}
            modules={[FreeMode, Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            <SwiperSlide className="mb-5">
              <img src={DHLlogo} width={250} height={80} alt="dhllogo" />
            </SwiperSlide>

            <SwiperSlide>
              <img src={UPSlogo} width={250} height={80} alt="upslogo" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={DHLElogo} width={250} height={80} alt="dhlecommerce" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Feedexlogo} width={250} height={80} alt="fedexlogo" />
            </SwiperSlide>
          </Swiper>

          <h5 className="fw-light text-center my-5 p-3">{t("TrustLogos")}</h5>

          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            pagination={{
              clickable: true,
            }}
            modules={[FreeMode, Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            <SwiperSlide className="mb-5">
              <img src={TimLogo} className="imgw-50" alt="timlogo" />
            </SwiperSlide>
            <SwiperSlide>
              <a
                href="https://www.eticaret.gov.tr/siteprofil/3722257853662862/mukemelcom"
                target="__blank"
              >
                <img src={EtbisNewLogo} className="imgw-50" alt="etbislogo" />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={ImmisLogo}
                className="imgw-50 mt-3"
                alt="dhlecommerce"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img src={IkbimLogo} className="imgw-50" alt="IkbimLogo" />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default SecureShoppingInformation;
